import React, { Component } from 'react';
import '../../scss/components/_user-testimony-card-no-logo.scss'


class UserTestimonyCardNoLogo extends Component {
    render(){
            return (
                <div className="userTestimonyCard-NoLogo" style={{backgroundColor:this.props.cardColor}}>
                    <div className="testimonialContent">
                        {this.props.testimony}
                    </div>
                    <div className="testimonyAuthorContainer d-flex ml-2">
                        <img src={this.props.image} alt={this.props.name}  />
                        <div className="pl-2 pr-2">
                            <div>
                                <p className="my-0"><b>{this.props.name}</b></p>
                            </div>
                            <div>
                                <p className="my-0 minorBlueHeader text-left">{this.props.position} </p>
                            </div>
                        </div>
                    </div> 
                </div> 
        )
    }
}


export default UserTestimonyCardNoLogo;